<transition name="fade">
  <div :class="$style.overlay" v-if="visibility">
    <div :class="$style.overlayInner">
      <v-grid contain :class="['mt-wrapper', $style.overlayWrapper]">
        <v-row>
          <v-col :has="cols" :off="offSpace">
            <div :class="getCustomPackageModal ? $style.customPackageContent : getFoundryModal ? $style.customContent : $style.overlayContent" @click.stop.prevent>
              <overlay-content :id="$vId(this)" />
              <button v-if="!liveSpinner"
                :id="$vId(this, 'hide')"
                :class="[$style.crossImage, $style.overlayClose]"
                @click="emitClose()"
                :disabled="getLiveModalCancelButton">
              </button>
            </div>
          </v-col>
        </v-row>
      </v-grid>
    </div>
  </div>
</transition>
